class EliteAestheticsCourseInfo extends HTMLElement {
  constructor() {
    super();
    this.product = null;
  }

  connectedCallback() {
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this.handleOptionValueChange.bind(this)
    );
  }

  async handleOptionValueChange({ data: { event, target } }) {
    if (!this.contains(event.target)) return;

    this.resetProductFormState();

    const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
    this.pendingRequestUrl = productUrl;

    if (!this.product) {
      const res = await fetch(`${window.location.origin}/${productUrl}.js`);
      const resJson = await res.json();
      this.product = resJson;
    }

    const { options, variants } = this.product;

    const currentVariantId = parseInt(this.productForm.variantIdInput.value, 10);
    const currentVariantOptions = this.getVariantOptions(currentVariantId, variants);

    const targetOption = this.getTargetOption(target);

    // We build the new options array for the desired variant
    const targetVariantOptions = [...currentVariantOptions];
    targetVariantOptions[targetOption.position - 1] = targetOption.value;

    const targetVariant = this.getVariantFromOptions(targetVariantOptions, variants);

    this.updateFormVariant(targetVariant.id);
    this.updateFormState(targetVariant, options, variants);
  }

  resetProductFormState() {
    const productForm = this.productForm;
    productForm?.toggleSubmitButton(true);
    productForm?.handleErrorMessage();
  }

  /**
   * We cannot use the selectedOptionValues because the option ids are not
   * available on the product json object. We nee to figure out the target
   * option value and name from the target element name attribute.
   * @param {HTMLElement} target
   */
  getTargetOption(target) {
    const namePattern = /^(.*)-(\d+)$/gm;
    const match = namePattern.exec(target.name);

    if (match) {
      return {
        name: match[1],
        position: parseInt(match[2], 10),
        value: target.value,
      };
    }
  }

  /**
   * Searches and returns the options for the given variant id sorted by option
   * position.
   * @param {string} currentVariantId
   * @param {Array} productVariants
   * @returns
   */
  getVariantOptions(currentVariantId, productVariants) {
    const foundProductVariants = productVariants.find((v) => v.id === currentVariantId)?.options;
    return foundProductVariants.length > 0 ? [...foundProductVariants] : []; // Better to have a pure function
  }

  /**
   * Searches and returns the variant that matches the given options.
   * @param {Array} options
   * @param {Array} productVariants
   * @returns
   */
  getVariantFromOptions(options, productVariants) {
    return productVariants.find(
      (v) =>
        options.length === v.options.length &&
        v.options.every((option, index) => {
          return option === options[index];
        })
    );
  }

  /**
   * Updates the form variant id to the target
   * @param {number} targetVariantId
   */
  updateFormVariant(targetVariantId) {
    this.productForm.form.id.value = targetVariantId;
  }

  /**
   * Updates the form state based, disabling the options that are not available
   * given the current variant, the selected options and the available variants.
   * @param {object} currentVariant 
   * @param {object} productOptions 
   * @param {object} productVariants 
   */
  updateFormState(currentVariant, productOptions, productVariants) {
    // Update option availability
    productOptions.forEach((option) => {
      option.values.forEach((optionValue) => {
        const targetOptions = [...currentVariant.options]
        targetOptions[option.position - 1] = optionValue;

        const targetVariant = this.getVariantFromOptions(targetOptions, productVariants);

        const optionElement = this.productForm.querySelector(`[name="${option.name}-${option.position}"][value="${optionValue}"]`);

        if (targetVariant.available) {
          optionElement.classList.remove('disabled');
        } else {
          optionElement.classList.add('disabled');
        }
      })
    })
    
    // Update submit button state
    if (currentVariant.available) {
      this.productForm.toggleSubmitButton(false);
    } else {
      this.productForm.toggleSubmitButton(true, window.variantStrings.soldOut);
    }
  }

  get productForm() {
    return this.querySelector(`product-form`);
  }
}
if (!customElements.get("ea-course-info")) {
  customElements.define("ea-course-info", EliteAestheticsCourseInfo);
}
